// src/components/admin/scheduling/components/SchedulingSettingsModal.js
// Focused "Tutor Display Order" editor, opened from the scheduling settings hub.
import React, { useEffect, useState } from "react";
import "./SchedulingSettingsModal.css";

export default function SchedulingSettingsModal({
  open,
  onClose,
  tutors = [],
  currentTutorOrder = [],
  onSave,
}) {
  const [localTutorList, setLocalTutorList] = useState([]);
  const [draggedItem, setDraggedItem] = useState(null);

  useEffect(() => {
    if (!open) return;

    const orderedIds = new Set(currentTutorOrder);
    const orderedTutors = currentTutorOrder
      .map((id) => tutors.find((t) => t.id === id))
      .filter(Boolean);
    const remainingTutors = tutors.filter((t) => !orderedIds.has(t.id));
    setLocalTutorList([...orderedTutors, ...remainingTutors]);
  }, [open, tutors, currentTutorOrder]);

  const handleDragStart = (e, index) => {
    setDraggedItem(localTutorList[index]);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", index);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    const draggedOverItem = localTutorList[index];
    if (draggedItem === draggedOverItem) return;
    const items = localTutorList.filter((item) => item !== draggedItem);
    items.splice(index, 0, draggedItem);
    setLocalTutorList(items);
  };

  const handleSaveTutorOrder = () => {
    const newTutorOrderIds = localTutorList.map((t) => t.id);
    onSave?.({ newTutorOrder: newTutorOrderIds });
  };

  if (!open) return null;

  return (
    <div
      className="schedModalOverlay"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="schedModalCard" onMouseDown={(e) => e.stopPropagation()}>
        <div className="schedModalHeader">
          <div className="schedModalTitle">Tutor Display Order</div>
          <button className="schedModalClose" onClick={onClose}>✕</button>
        </div>

        <div className="schedModalBody">
          <div className="schedField" style={{ marginBottom: 0 }}>
            <p className="tutorListHint">Drag and drop to reorder how tutors appear on the schedule.</p>
            <ul className="sortableList">
              {localTutorList.map((tutor, index) => (
                <li
                  key={tutor.id}
                  className="sortableItem"
                  draggable
                  onDragStart={(e) => handleDragStart(e, index)}
                  onDragOver={(e) => handleDragOver(e, index)}
                >
                  <span className="dragHandle">☰</span>
                  <span className="tutorName">{tutor.name || tutor.email}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="schedModalFooter">
          <button className="schedModalBtn" onClick={onClose}>Cancel</button>
          <button className="schedModalBtn schedModalBtn--primary" onClick={handleSaveTutorOrder}>
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}
